module.exports = __webpack_public_path__ + "static/f3d35e48225fcae1bcc507f919e22da0.svg";